var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "error" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("main", [
        _c(
          "div",
          { staticClass: "wrapper" },
          [
            _vm._l(_vm.errorMessages, function(message, index) {
              return _c("div", { key: "error-" + index }, [
                _vm._v(_vm._s(message))
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "toplink" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.toTop()
                    }
                  }
                },
                [_vm._v("トップ画面へ戻る")]
              )
            ])
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92bc6c8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92bc6c8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcError.vue
// module id = null
// module chunks = 